<div class="course-form">

  <header class="cf-head">
    <span class="cf-head__icon"><i class="fas fa-check-double" aria-hidden="true"></i></span>
    <div class="cf-head__text">
      <h1 class="cf-head__title">Marksheet</h1>
      <p class="cf-head__sub">Every student's score for this assessment</p>
    </div>
  </header>

  <section class="cf-card">
    <!-- The grid is built by angular-datatables against this element, which is why the table is
         empty here and why the search box and Excel button come from that library rather than the
         page. M04 deferred retiring it to this milestone; see M10-findings.md. -->
    <div class="cf-table-wrap" [hidden]="loadFailed">
      <table #dataTable class="cf-table"></table>
    </div>

    <p class="cf-empty" *ngIf="loadFailed">
      The marksheet could not be loaded. Please try again.
    </p>
  </section>
</div>
